import { render, staticRenderFns } from "./duoge.vue?vue&type=template&id=ccefab32&scoped=true"
import script from "./duoge.vue?vue&type=script&lang=js"
export * from "./duoge.vue?vue&type=script&lang=js"
import style0 from "./duoge.vue?vue&type=style&index=0&id=ccefab32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccefab32",
  null
  
)

export default component.exports